module.exports = __webpack_public_path__ + "static/media/tags.2d1a9175.png";